module.exports = __webpack_public_path__ + "img/c-thermometer-img5-2.72ef5c94.png";